





















import { Component, Vue } from 'vue-property-decorator';
import { Data } from '@/models/dynamiclist';
import { Getter } from 'vuex-class';
import { Filter } from '@/models/dynamiclist';
import SearchFilterComponent from './components/filters/SearchFilter.vue';
import Results from './components/results/Results.vue';
import ResultsComponent from './components/results/Results.vue';
import SelectedFacetsComponent from './components/filters/SelectedFacets.vue';
import FacetFilterComponent from './components/filters/FacetFilter.vue';

@Component({
    components: {
        SearchFilterComponent,
        FacetFilterComponent,
        ResultsComponent,
        SelectedFacetsComponent
    }
})
export default class App extends Vue {
    @Getter
    public filterRows!: Filter[][];

    @Getter
    public filterQueries: any;
}
